import { Group, LineItem, Material } from '../../../types/ffe'
import { Typography } from 'antd'
import { formatCurrency } from '../../../utils/currency'
import { calculateLineItemTotal } from '../../../utils/calculations'
import { TableItemIndent } from './PrintGroup'
const { Text } = Typography

export const PrintLineItem = ({
  item,
  group,
  documentSettings,
  materials,
  depth
}: {
  item: LineItem
  group?: Group
  materials: Array<Material>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  documentSettings: any
  depth: number
}) => {
  const itemMaterials =
    item.materials
      ?.map((mat) => {
        const material = materials.find((m) => m.id === mat.materialId)
        return {
          ...mat,
          ...material
        }
      })
      .filter(Boolean) || []

  const renderMaterials = () => {
    const finishes = itemMaterials.filter(
      (m) => m.materialType === 'finish' && !m.hideOnDocument
    )
    if (!finishes?.length) return null

    return (
      <div className="mt-2">
        <Text type="secondary" className="text-sm">
          Finishes:
        </Text>
        <div className="grid grid-cols-2 gap-2 mt-1">
          {finishes.map((material) => {
            return (
              <div
                key={material.materialId}
                className="flex items-center gap-2"
              >
                {material.image && (
                  <img
                    src={material.image.url}
                    alt={material.image.alt}
                    className="w-9 h-9 object-cover rounded"
                  />
                )}
                <div className="flex-1">
                  {/* <Text type="secondary" className="text-xs">
                    {material.quantity} {material.unit}
                  </Text> */}
                  {!documentSettings.hideMaterialNames && (
                    <Text className="text-sm block">{material.name}</Text>
                  )}
                  {documentSettings.showMaterialQuantity && (
                    <Text type="secondary" className="text-xs">
                      {material.quantity} {material.unit}
                    </Text>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  const renderAccessories = () => {
    const accessories = itemMaterials.filter(
      (m) => m.materialType === 'accessory' && !m.hideOnDocument
    )
    if (!accessories?.length) return null

    return (
      <div className="mt-2">
        <Text type="secondary" className="text-sm">
          Accessories:
        </Text>
        <div className="grid grid-cols-2 gap-2 mt-1">
          {accessories.map((material) => {
            return (
              <div
                key={material.materialId}
                className="flex items-center gap-2"
              >
                {material.image && (
                  <img
                    src={material.image.url}
                    alt={material.image.alt}
                    className="w-9 h-9 object-cover rounded"
                  />
                )}
                <div className="flex-1">
                  <Text className="text-sm block">{material.name}</Text>
                  {documentSettings.showMaterialQuantity && (
                    <Text type="secondary" className="text-xs">
                      {material.quantity} {material.unit}
                    </Text>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  const total = calculateLineItemTotal(item, materials)

  const alternativeClass = `${group?.isAlternatives && group.selectedItemId !== item.id ? 'opacity-55' : ''}`

  return (
    <tr key={item.id} className={`break-inside-avoid`}>
      <td className="p-0 m-0 border-none">
        <div className="flex items-stretch p-0">
          <TableItemIndent depth={depth} />
          <div
            className={`flex-1 border-b border-gray-100 flex items-start gap-4 ${group && 'pl-6'} py-4 ${alternativeClass}`}
            style={{}}
          >
            {item.image && (
              <img
                src={item.image.url}
                alt={item.image.alt}
                className="w-20 h-20 object-cover rounded"
                style={{ objectFit: 'contain' }}
              />
            )}
            <div>
              <div className="flex items-center gap-2">
                {item.code && (
                  <Text className="font-mono break-keep text-sm">
                    {item.code}
                  </Text>
                )}
                <Text
                  strong
                  className="text-sm">
                  {item.name}
                </Text>
                {group?.isAlternatives && group.selectedItemId !== item.id && (
                  <Text className="text-sm break-keep">(Alternative)</Text>
                )}
              </div>
              {item.description && (
                <Text className="text-sm text-gray-600 block mt-1">
                  {item.description}
                </Text>
              )}
              {item.leadTime && documentSettings.showLeadTimes && (
                <Text className="text-sm text-gray-600 block mt-1">
                  Lead time: {item.leadTime}
                </Text>
              )}
              {documentSettings.showSupplierDetails && (
                <div className="text-sm flex items-center gap-2">
                  {item.supplier && (
                    <Text className="text-gray-500 text-sm block">
                      Supplier: {item.supplier}
                    </Text>
                  )}
                  {item.supplierItemCode && (
                    <Text className="text-sm text-gray-500 text-sm block">
                      Item: {item.supplierItemCode}
                    </Text>
                  )}
                </div>
              )}
              {renderMaterials()}
              {renderAccessories()}
            </div>
          </div>
        </div>
      </td>
      <td className={`h-full p-0 ${alternativeClass}`}>
        <div className="text-sm h-full flex items-center justify-end px-2 border-b border-gray-100">
          {item.quantity}
        </div>
      </td>
      {documentSettings.showClientPrices && (
        <>
          <td className={`h-full p-0 ${alternativeClass}`}>
            <div className="text-sm h-full flex items-center justify-end px-2 border-b border-gray-100">
              {formatCurrency(total / item.quantity)}
            </div>
          </td>
          <td className={`h-full p-0 ${alternativeClass}`}>
            <div className="text-sm h-full flex items-center justify-end px-2 border-b border-gray-100">
              {formatCurrency(total)}
            </div>
          </td>
        </>
      )}
    </tr>
  )
}
